<template>
  <div
    class="ModalAside"
    :class="{ 'ModalAside--Opened': modelValue }"
    @click="close($event)"
  >
    <div class="ModalAsideDialog">
      <div class="ModalAsideContent rounded-l-md">
        <slot v-bind="{ close }"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import asideModalDisplayed from './AsideModalContext'

export default {
  emits: ['update:modelValue', 'close'],
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close($event) {
      if (
        $event === undefined ||
        !this.$el.contains($event.target) ||
        this.$el === $event.target
      ) {
        if ($event) {
          $event.preventDefault()
        }
        this.$emit('update:modelValue', false)
        this.$emit('close')
      }
    },
    closeOnEscape(e) {
      if (!this.modelValue) return
      if (e.key === 'Escape') {
        this.close()
      }
    }
  },
  provide() {
    return {
      closeModal: this.close
    }
  },
  watch: {
    modelValue: {
      handler(newVal) {
        if (newVal) {
          document.querySelector('html').classList.add('lock')
          document.querySelector('body').classList.add('lock')
          asideModalDisplayed.value = true
        } else {
          document.querySelector('html').classList.remove('lock')
          document.querySelector('body').classList.remove('lock')
          asideModalDisplayed.value = false
        }
      },
      immediate: true
    }
  },
  mounted() {
    document.addEventListener('keydown', this.closeOnEscape)
  },
  unmounted() {
    document.removeEventListener('keydown', this.closeOnEscape)
  }
}
</script>

<style lang="scss" scoped>
.ModalAside {
  @apply fixed block overflow-hidden;
  @apply right-0 bottom-0 left-0;

  top: 40px;
  background: rgba(#000, 0.75);
  z-index: 100;
  outline: 0;
  opacity: 0;
  z-index: -1;
  visibility: hidden;

  transition: 300ms ease-in;
}

.ModalAside--Opened {
  opacity: 1;
  z-index: 100;
  visibility: visible;

  .ModalAsideContent {
    transform: translateX(0%);
  }
}

.ModalAsideDialog {
  @apply relative w-auto flex;

  max-width: 700px;
  margin: 0;
  /*margin-top: 40px;*/
  margin-left: auto;
  height: 100%;
  pointer-events: none;
}

.ModalAsideContent {
  @apply relative flex flex-col w-full;
  @apply bg-gray-200;

  background-clip: padding-box;
  outline: 0;
  pointer-events: auto;

  transform: translateX(100%);
  transition: 300ms ease-out;
}
</style>
